import React, { useEffect, useState } from "react";
import api from "../../utils/api";

const Details = () => {
    const [companyName, setCompanyName] = useState("");
    const [logo, setLogo] = useState(null);
    const [favicon, setFavicon] = useState(null);
    const [logoPreview, setLogoPreview] = useState("");
    const [faviconPreview, setFaviconPreview] = useState("");
    const [loading, setLoading] = useState(false);
    const [logo2, setLogo2] = useState(null);
    const [logo2Preview, setLogo2Preview] = useState("");

    const [banner, setBanner] = useState(null);
const [bannerPreview, setBannerPreview] = useState("");

    useEffect(() => {
        fetchDetails();
    }, []);

async function fetchDetails() {
    try {
        const loggedInUser = localStorage.getItem("loggedInUser");
        const token = localStorage.getItem("authToken");

        const fd = new FormData();
        fd.append("loggedInUser", loggedInUser);
        fd.append("token", token);
        fd.append("programType", "getCompanyDetails");

        const response = await api.post("settings/setting", fd);
        console.log("Company details response:", response);

        const data = response.data.data;

        setCompanyName(data.company_name);
        setLogoPreview(data.logo_url);
        setFaviconPreview(data.favicon_url);

        if (data.logo2_url) {
            setLogo2Preview(data.logo2_url);
        }

        // ✅ ADD THIS
        if (data.banner_url) {
            setBannerPreview(data.banner_url);
        }

           if (data.company_name) {
                    localStorage.setItem("companyName", data.company_name);
                }

                if (data.logo_url) {
                    localStorage.setItem("logo1", data.logo_url);
                }

                 if (data.banner_url) {
                    localStorage.setItem("banner", data.banner_url);
                }

                if (data.logo2_url) {
                    localStorage.setItem("logo2", data.logo2_url);
                }

                if (faviconPreview) {
                    localStorage.setItem("favicon", faviconPreview);

                    const link =
                        document.querySelector("link[rel*='icon']") ||
                        document.createElement("link");

                    link.type = "image/x-icon";
                    link.rel = "shortcut icon";
                    link.href = faviconPreview;

                    document.getElementsByTagName("head")[0].appendChild(link);
                }


    } catch (error) {
        console.error("Error fetching company details:", error);
    }
}

const handleFileChange = (e, type) => {
    const file = e.target.files[0];
    if (!file) return;

    const previewUrl = URL.createObjectURL(file);

    if (type === "logo") {
        setLogo(file);
        setLogoPreview(previewUrl);
    }
    else if (type === "logo2") {
        setLogo2(file);
        setLogo2Preview(previewUrl);
    }
    else if (type === "banner") {
        setBanner(file);
        setBannerPreview(previewUrl);
    }
    else {
        setFavicon(file);
        setFaviconPreview(previewUrl);
    }
};
    async function handleSubmitDetails(e) {
        e.preventDefault();
        setLoading(true);

        try {
            const fd = new FormData();
            fd.append("loggedInUser", localStorage.getItem("loggedInUser"));
            fd.append("token", localStorage.getItem("authToken"));
            fd.append("programType", "updateCompany");
            fd.append("company_name", companyName);

            if (logo) fd.append("logo", logo);
            if (logo2) fd.append("logo2", logo2);
            if (favicon) fd.append("favicon", favicon);
            if (banner) fd.append("banner", banner);

            fd.entries().forEach(([key, value]) => {
                console.log(`${key}:`, value);
            });

            const res = await api.post("settings/setting", fd);
            console.log("Update response:", res);

            if (res.data.success) {
                alert(res.data.message || "Company details updated successfully!");

                const data = res.data.data || {};

             
                fetchDetails();
            } else {
                alert(res.data.message || "Update failed. Please try again.");
            }




            // reload details preview
            fetchDetails();
        } catch (error) {
            console.log("Update failed. Please try again.");
        } finally {
            setLoading(false);
        }
    }


    return (
        <div style={styles.container}>
            <div style={styles.card}>
                <header style={styles.header}>
                    <h2 style={styles.title}>Company Settings</h2>
                    <p style={styles.subtitle}>Update your brand identity and assets</p>
                </header>

                <form onSubmit={handleSubmitDetails} style={styles.form}>
                    {/* Company Name */}
                    <div style={styles.inputGroup}>
                        <label style={styles.label}>Company Name</label>
                        <input
                            type="text"
                            value={companyName}
                            onChange={(e) => setCompanyName(e.target.value)}
                            placeholder="e.g. Acme Corp"
                            required
                            style={styles.input}
                        />
                    </div>

                    <div style={styles.grid}>
                        {/* Logo Upload */}
                        <div style={styles.uploadSection}>
                            <label style={styles.label}>Brand Logo</label>
                            <div style={styles.previewBox}>
                                {logoPreview ? (
                                    <img src={logoPreview} alt="Logo" style={styles.logoImg} />
                                ) : (
                                    <div style={styles.placeholder}>No Logo</div>
                                )}
                            </div>
                            <input
                                type="file"
                                accept="image/*"
                                onChange={(e) => handleFileChange(e, "logo")}
                                style={styles.fileInput}
                                id="logo-upload"
                            />
                            <label htmlFor="logo-upload" style={styles.fileInputLabel}>
                                Choose Logo
                            </label>
                        </div>

                        {/* Secondary Logo Upload */}
                        <div style={styles.uploadSection}>
                            <label style={styles.label}>Secondary Logo</label>

                            <div style={styles.previewBox}>
                                {logo2Preview ? (
                                    <img src={logo2Preview} alt="Logo2" style={styles.logoImg} />
                                ) : (
                                    <div style={styles.placeholder}>No Secondary Logo</div>
                                )}
                            </div>

                            <input
                                type="file"
                                accept="image/*"
                                onChange={(e) => handleFileChange(e, "logo2")}
                                style={styles.fileInput}
                                id="logo2-upload"
                            />

                            <label htmlFor="logo2-upload" style={styles.fileInputLabel}>
                                Choose Secondary Logo
                            </label>
                        </div>

                        {/* Favicon Upload */}
                        <div style={styles.uploadSection}>
                            <label style={styles.label}>Favicon (Browser Icon)</label>
                            <div style={styles.previewBox}>
                                {faviconPreview ? (
                                    <img src={faviconPreview} alt="Favicon" style={styles.faviconImg} />
                                ) : (
                                    <div style={styles.placeholder}>No Icon</div>
                                )}
                            </div>
                            <input
                                type="file"
                                accept="image/*"
                                onChange={(e) => handleFileChange(e, "favicon")}
                                style={styles.fileInput}
                                id="favicon-upload"
                            />
                            <label htmlFor="favicon-upload" style={styles.fileInputLabel}>
                                Choose Favicon
                            </label>
                        </div>

                        {/* Banner Upload */}
<div style={styles.uploadSection}>
    <label style={styles.label}>Banner</label>

    <div style={styles.previewBox}>
        {bannerPreview ? (
            <img src={bannerPreview} alt="Banner" style={{ width: "100%", height: "100%", objectFit: "cover" }} />
        ) : (
            <div style={styles.placeholder}>No Banner</div>
        )}
    </div>

    <input
        type="file"
        accept="image/*"
        onChange={(e) => handleFileChange(e, "banner")}
        style={styles.fileInput}
        id="banner-upload"
    />

    <label htmlFor="banner-upload" style={styles.fileInputLabel}>
        Choose Banner
    </label>
</div>
                    </div>

                    <button
                        type="submit"
                        disabled={loading}
                        style={{
                            ...styles.button,
                            opacity: loading ? 0.7 : 1,
                            cursor: loading ? 'not-allowed' : 'pointer'
                        }}
                        onMouseEnter={(e) => {
                            if (!loading) e.target.style.backgroundColor = "#1d4ed8";
                        }}
                        onMouseLeave={(e) => {
                            if (!loading) e.target.style.backgroundColor = "#2563eb";
                        }}
                    >
                        {loading ? "Saving Changes..." : "Save Settings"}
                    </button>
                </form>
            </div>
        </div>
    );
};

// Responsive CSS-in-JS
const styles = {
    container: {
        padding: "20px",
        backgroundColor: "#f9fafb",
        minHeight: "100vh",
        fontFamily: "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif",
    },
    card: {
        maxWidth: "800px",
        margin: "0 auto",
        backgroundColor: "#fff",
        borderRadius: "12px",
        boxShadow: "0 4px 6px -1px rgba(0,0,0,0.1), 0 2px 4px -1px rgba(0,0,0,0.06)",
        padding: "32px",
    },
    header: {
        marginBottom: "24px",
        borderBottom: "1px solid #f3f4f6",
        paddingBottom: "16px",
    },
    title: {
        fontSize: "24px",
        fontWeight: "700",
        color: "#111827",
        margin: 0,
    },
    subtitle: {
        fontSize: "14px",
        color: "#6b7280",
        marginTop: "4px",
    },
    form: {
        display: "flex",
        flexDirection: "column",
        gap: "24px",
    },
    inputGroup: {
        width: "100%",
    },
    label: {
        display: "block",
        fontSize: "14px",
        fontWeight: "600",
        color: "#374151",
        marginBottom: "8px",
    },
    input: {
        width: "100%",
        padding: "10px 12px",
        borderRadius: "8px",
        border: "1px solid #d1d5db",
        fontSize: "16px",
        boxSizing: "border-box",
        transition: "border-color 0.2s, box-shadow 0.2s",
        outline: "none",
    },
    grid: {
        display: "grid",
        gridTemplateColumns: "repeat(auto-fit, minmax(220px, 1fr))",
        gap: "24px",
    },
    uploadSection: {
        width: "100%",
    },
    previewBox: {
        height: "120px",
        backgroundColor: "#f9fafb",
        borderRadius: "8px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        marginBottom: "12px",
        overflow: "hidden",
        border: "2px dashed #e5e7eb",
    },
    logoImg: {
        maxHeight: "100px",
        maxWidth: "100%",
        objectFit: "contain",
    },
    faviconImg: {
        height: "48px",
        width: "48px",
        objectFit: "contain",
    },
    placeholder: {
        color: "#9ca3af",
        fontSize: "12px",
        fontWeight: "500",
    },
    fileInput: {
        position: "absolute",
        width: "1px",
        height: "1px",
        padding: "0",
        margin: "-1px",
        overflow: "hidden",
        clip: "rect(0, 0, 0, 0)",
        whiteSpace: "nowrap",
        border: "0",
    },
    fileInputLabel: {
        display: "inline-block",
        padding: "8px 16px",
        backgroundColor: "#f3f4f6",
        color: "#374151",
        fontSize: "14px",
        fontWeight: "500",
        borderRadius: "6px",
        cursor: "pointer",
        textAlign: "center",
        width: "100%",
        boxSizing: "border-box",
        transition: "background-color 0.2s",
    },
    button: {
        marginTop: "10px",
        backgroundColor: "#2563eb",
        color: "white",
        padding: "12px 24px",
        borderRadius: "8px",
        border: "none",
        fontWeight: "600",
        fontSize: "16px",
        cursor: "pointer",
        transition: "all 0.2s",
    }
};

// Add CSS for responsive behavior and hover states
const styleSheet = document.createElement("style");
styleSheet.textContent = `
  /* Desktop styles (default) */
  .preview-box:hover {
    border-color: #2563eb !important;
  }
  
  .file-input-label:hover {
    background-color: #e5e7eb !important;
  }
  
  button:hover:not(:disabled) {
    background-color: #1d4ed8 !important;
    transform: translateY(-1px) !important;
  }
  
  button:active:not(:disabled) {
    transform: translateY(0) !important;
  }
  
  input:focus {
    border-color: #2563eb !important;
    box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.1) !important;
    outline: none !important;
  }
  
  /* Mobile responsive styles */
  @media (max-width: 768px) {
    .responsive-card {
      padding: 20px !important;
    }
    
    .responsive-grid {
      grid-template-columns: 1fr !important;
      gap: 20px !important;
    }
    
    .responsive-title {
      font-size: 20px !important;
    }
    
    .responsive-subtitle {
      font-size: 12px !important;
    }
    
    .responsive-preview-box {
      height: 100px !important;
    }
    
    .responsive-logo-img {
      max-height: 80px !important;
    }
    
    .responsive-favicon-img {
      height: 40px !important;
      width: 40px !important;
    }
    
    .responsive-button {
      padding: 12px 20px !important;
      font-size: 14px !important;
    }
    
    input, button {
      font-size: 16px !important; /* Prevents zoom on mobile inputs */
    }
  }
`;

// Add styles to document head if not already added
if (!document.querySelector('#company-settings-styles')) {
    styleSheet.id = 'company-settings-styles';
    document.head.appendChild(styleSheet);
}

// Apply responsive classes
const responsiveContainer = {
    ...styles.container,
    className: "responsive-container"
};

const responsiveCard = {
    ...styles.card,
    className: "responsive-card"
};

const responsiveGrid = {
    ...styles.grid,
    className: "responsive-grid"
};

const responsiveTitle = {
    ...styles.title,
    className: "responsive-title"
};

const responsiveSubtitle = {
    ...styles.subtitle,
    className: "responsive-subtitle"
};

const responsivePreviewBox = {
    ...styles.previewBox,
    className: "preview-box responsive-preview-box"
};

const responsiveLogoImg = {
    ...styles.logoImg,
    className: "responsive-logo-img"
};

const responsiveFaviconImg = {
    ...styles.faviconImg,
    className: "responsive-favicon-img"
};

const responsiveButton = {
    ...styles.button,
    className: "responsive-button"
};

export default Details;